import { zip, unzip } from "../../../../lib/utils/zip.js";
import { AbstractStorage } from "./AbstractStorage.js";
class ZipStorage extends AbstractStorage {
  get(key) {
    const value = this.store.get(key);
    if (value) {
      return unzip(value);
    }
    return value;
  }
  set(key, value) {
    this.store.set(key, zip(value));
  }
  has(key) {
    return this.store.has(key);
  }
  delete(key) {
    this.store.delete(key);
  }
}
export {
  ZipStorage
};
//# sourceMappingURL=ZipStorage.js.map
